import React, { useEffect, useMemo } from 'react';
import OptimizelyContext from './OptimizelyContext';
import getOptimizelyInstance, { updateOptimizelyDataFile } from './getOptimizelyInstance';
import { setUserId } from './optimizelyTrack';
import { forceExperiments } from './forceOptimizelyExperiments';
import OptimizelyTestDecisionListener from './OptimizelyTestDecisionListener';
import { jsx as _jsx } from "react/jsx-runtime";
function OptimizelyPageProvider({
  children,
  disabled,
  optimizelyDynamicConfig = {},
  listenerConfig = {}
}) {
  const enabled = !disabled && optimizelyDynamicConfig.dataFile && optimizelyDynamicConfig.dataFile.revision;
  if (enabled) {
    updateOptimizelyDataFile(optimizelyDynamicConfig.dataFile);
  }

  // This is only to support optimizelyTrack (which doesn't use OptimizelyContext)
  useEffect(() => {
    if (enabled && optimizelyDynamicConfig?.user) {
      setUserId(optimizelyDynamicConfig?.user?.id);
    }
  }, [enabled, optimizelyDynamicConfig]);

  // Skip the rest of config set up if not enabled
  if (!enabled) {
    return children;
  }

  // Support for forcing experiments in Bonnet 9
  // NOTE: Previously only located in the ctx-middleware which now only runs on the server on initial load (Bonnet 9).
  // This loses the forced experiment decisions on the client
  // Will not work in a useEffect as that hook runs after the first render and some decisions could have already been made
  const {
    forcedExperiments,
    user
  } = optimizelyDynamicConfig;
  if (forcedExperiments && forcedExperiments.length) {
    forceExperiments(forcedExperiments, user?.id);
  }
  const optimizelyInstance = getOptimizelyInstance();
  OptimizelyTestDecisionListener(optimizelyInstance, listenerConfig, user?.id);
  const userInstance = optimizelyInstance.createUserContext(user?.id, user?.attributes);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const providerValue = useMemo(() => ({
    ...optimizelyDynamicConfig,
    userInstance: userInstance || {}
  }), [optimizelyDynamicConfig, userInstance]);
  return /*#__PURE__*/_jsx(OptimizelyContext.Provider, {
    value: providerValue,
    children: children
  });
}
export default OptimizelyPageProvider;